module.exports = __webpack_public_path__ + "static/media/sample_3-05.6f2464e8.jpg";